import type { LearnTopic } from '../types';
import { $, $0, width } from '../format';

export const condorTopic: LearnTopic = {
  id: 'condor',
  tier: 'position',
  title: 'The iron condor is two spreads',
  summary:
    'A short put spread below the price and a short call spread above it. Each earns its own credit; the wings cap what each can lose.',
  body: [
    'An iron condor is two credit spreads sold at the same time on the same expiration: a put spread below the current price and a call spread above it. You collect a credit for each, and the total is what you are paid to take the position. It builds straight on Spreads above — each side is one of the two-leg spreads described there.',
    'The short put spread earns its full credit if the stock stays above the short put through expiration. The short call spread earns its full credit if the stock stays below the short call. Both can win at once, which is the point: you profit if the stock stays inside the two short strikes.',
    'Each spread has a long option further out — the wing. The wing is insurance: it caps the loss on that side at the distance between the two strikes, minus the credit you collected. Without wings you would have a strangle — the same short put and short call with no wings — and the loss on either side would be open-ended.',
  ],
  explain(ctx) {
    const { shortPut, longPut, shortCall, longCall, credit } = ctx;
    if (shortPut == null || longPut == null || shortCall == null || longCall == null) {
      return ['This position does not have both spreads open, so it is not a full iron condor right now.'];
    }
    return [
      `Your put spread is short the ${shortPut} put and long the ${longPut} put, ${width(shortPut, longPut)} wide.`,
      `Your call spread is short the ${shortCall} call and long the ${longCall} call, ${width(longCall, shortCall)} wide.`,
      credit != null
        // Per-contract money in whole dollars ("$140"): the cents are the per-share figure's job.
        ? `You collected ${$(credit)} per share for the pair, ${$0(credit * 100)} per contract.`
        : 'The credit collected is not recorded on this position.',
    ];
  },
  appliesTo(ctx) {
    return ctx.shortPut != null && ctx.shortCall != null;
  },
};
